export default {
  methods: {
  },
  computed: {
    $allPricingGroups () {
      return this.$store.state.FacilityPricingTypeStore.all_facility_pricing_types
    }
  }
}
